import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';

const buildPermalink = (postId: string): string => {
  try {
    const baseUrl = (typeof window !== 'undefined' ? window.location.origin : '');
    if (!baseUrl) {
      return `/comments/${postId}`;
    }
    return `${baseUrl}/comments/${postId}`;
  } catch {
    return `/comments/${postId}`;
  }
};

export interface SharePostParams {
  id: string;
  title?: string;
}

export const sharePost = async ({ id, title }: SharePostParams): Promise<void> => {
  const url = buildPermalink(id);
  const displayTitle = title || 'Check out this post';
  const text = `${displayTitle}\n${url}`;

  const isNative = Capacitor.getPlatform && Capacitor.getPlatform() !== 'web';

  try {
    if (isNative && Share && Share.canShare) {
      const canShareResult = await Share.canShare();
      if (canShareResult && canShareResult.value) {
        await Share.share({
          title: 'Share post',
          text,
          dialogTitle: 'Share post',
        });
        return;
      }
    }

    if (typeof navigator !== 'undefined' && navigator.share) {
      await navigator.share({ title: 'Share post', text });
      return;
    }

    if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
    }
  } catch {
    // Silently ignore share errors; UI can optionally handle failures.
  }
};
